import { NumberFieldElement } from '@graphcommerce/ecommerce-ui'
import { ApolloCartErrorSnackbar, useFormGqlMutationCart } from '@graphcommerce/magento-cart'
import {
  UpdateItemQuantityDocument,
  UpdateItemQuantityMutation,
  UpdateItemQuantityMutationVariables,
} from '@graphcommerce/magento-cart-items/UpdateItemQuantity/UpdateItemQuantity.gql'
import { useFormAutoSubmit, UseFormGraphQlOptions } from '@graphcommerce/react-hook-form'
import { SxProps, Theme } from '@mui/material'
import { ChangeEvent } from 'react'

type UpdateItemQuantityFormReturn = UseFormGraphQlOptions<
  UpdateItemQuantityMutation,
  UpdateItemQuantityMutationVariables
>

export type UpdateItemQuantityProps = Omit<UpdateItemQuantityMutationVariables, 'cartId'> & {
  sx?: SxProps<Theme>
} & Omit<UpdateItemQuantityFormReturn, 'mode' | 'defaultValues'> & {
    max?: number
  }

export function UpdateItemQuantity(props: UpdateItemQuantityProps) {
  const { uid, quantity, sx = [], max, ...formProps } = props

  const form = useFormGqlMutationCart(UpdateItemQuantityDocument, {
    defaultValues: { uid, quantity },
    mode: 'onChange',
    ...formProps,
  })
  const { handleSubmit, formState, error, reset, control } = form

  const submit = handleSubmit(() => {})
  useFormAutoSubmit({ form, submit })

  return (
    <form noValidate onSubmit={submit}>
      <NumberFieldElement
        name='quantity'
        control={control}
        variant='outlined'
        inputProps={{
          min: 1,
          ...(max ? { max } : {}),
          onChange: (event: ChangeEvent<HTMLInputElement>) => {
            const inputValue = Number(event.target.value)

            if (max && inputValue > max) {
              event.target.value = max.toString()
            }
          },
        }}
        helperText={formState.errors.quantity?.message}
        sx={Array.isArray(sx) ? sx : [sx]}
      />
      <ApolloCartErrorSnackbar error={error} onClose={() => reset({ quantity })} />
    </form>
  )
}
